const LANGUAGES = {
  EN: "en-US",
  UA: "uk-UA",
};
export default LANGUAGES;
